<div class="page_wrapper">
    <div class="full_bg">
        <section class="signup_section">
            <div class="container">

                <div class="top_part">
                    <a (click)="goToHome()" class="back_btn" style="cursor: pointer;">
                        <i class="fa fa-arrow-left"></i> Back to home
                    </a>
                    <a class="navbar-brand" (click)="goToHome()" style="cursor: pointer;">
                        <img src="assets/images/auth/logo.png" alt="ShiftClock Logo">
                    </a>
                </div>

                <div class="form_block">

                    <div class="side_screen">
                        <div class="section_title">
                            <h2>Reset Your ShiftClock Password</h2>
                            <p>Enter your email below and we'll send you a link to reset your password securely.</p>
                        </div>
                    </div>

                    <div class="form_side">
                        <div class="section_title">
                            <span class="title_badge">Password Recovery</span>
                            <h4>Forgot your password?</h4>
                            <p>Don't worry! We'll help you get back into your account.</p>
                        </div>

                        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">

                            <div class="form-group">
                                <input type="email" formControlName="email" class="form-control" placeholder="Enter your email" [class.is-invalid]="f['email'].invalid && f['email'].touched">
                            </div>

                            <div class="form-group mb-3">
                                <label id="captchaLabel">{{ captchaQuestion }}</label>
                                <input type="text" formControlName="captchaInput" class="form-control" placeholder="Answer" [class.is-invalid]="f['captchaInput'].invalid && f['captchaInput'].touched">
                            </div>

                            <div class="btn_block">
                                <button type="submit" class="puprple_btn" [disabled]="isLoading">
                  {{ isLoading ? 'Sending OTP...' : 'Send OTP' }}
                </button>
                                <div class="btn_bottom"></div>
                            </div>

                            <div class="sign_in_here mt-3">
                                <p>Remembered your password? <a (click)="goToSignIn()" style="cursor: pointer;">Sign in here</a></p>
                            </div>

                            <div *ngIf="successMessage" class="message mt-2" style="display: block;">
                                {{ successMessage }}
                            </div>

                            <div *ngIf="errorMessage" class="error text-danger mt-2">
                                {{ errorMessage }}
                            </div>

                        </form>
                    </div>

                </div>

            </div>
        </section>
    </div>
</div>